import { TChatRoomHeaderContainerProps } from 'App/containers'
import {
  ChatRoomHeaderWrapper,
  ChatRoomHeaderUser,
  ChatRoomHeaderActions,
  ChatPinTitle
} from 'App/components'
import { EIconSize } from 'enums'
import { useChatContext } from 'App/context'

import { ChatRoomBackAction } from '../ChatRoomBackAction'

import styles from './ChatRoomHeaderCaseMember.module.scss'

export type TChatRoomHeaderCaseMemberProps = TChatRoomHeaderContainerProps

export const ChatRoomHeaderCaseMember = ({
  selectedChat,
  online,
  lastSeen,
  caseId,
  caseType,
  isChatRoomMuted,
  loading
}: TChatRoomHeaderCaseMemberProps) => {
  const { showPinnedMessages } = useChatContext()

  return (
    <ChatRoomHeaderWrapper
      loading={loading}
      backButton={<ChatRoomBackAction caseType={caseType} />}
      title={
        showPinnedMessages ? (
          <ChatPinTitle />
        ) : (
          <ChatRoomHeaderUser
            isChatRoomMuted={isChatRoomMuted}
            disabled={!!selectedChat?.case?.id}
            online={online}
            lastSeen={lastSeen}
            selectedChat={selectedChat}
            avatar={true}
            isCase={true}
          />
        )
      }
      actions={
        selectedChat &&
        !showPinnedMessages && (
          <ChatRoomHeaderActions
            id={selectedChat.id}
            type={selectedChat.type}
            status={selectedChat.status}
            userName={selectedChat.interlocutorAccount?.displayUserName}
            iconSize={EIconSize.MD}
            caseId={caseId}
            isOwner={false}
          />
        )
      }
      classes={{ root: styles.wrapperRoot }}
    />
  )
}
